import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environment/environment';

export type NewsletterSubscribeModel = {
  email: string;
  name?: string;
  firstName?: string;
  lastName?: string;
};

@Injectable({
  providedIn: 'root',
})
export class NewsletterService {
  constructor(private http: HttpClient) {}

  subscribe(newsletter: NewsletterSubscribeModel): Observable<void> {
    const formData = new FormData();
    formData.append('mode', 'subscribe');
    formData.append('email', newsletter.email.trim());

    if (newsletter.firstName) {
      formData.append('first_name', newsletter.firstName.trim());
    }
    if (newsletter.lastName) {
      formData.append('last_name', newsletter.lastName.trim());
    }
    if (newsletter.name) {
      formData.append('name', newsletter.name.trim());
    }

    return this.http
      .post<{
        success: boolean;
        message: string;
      }>(environment.authority_short + 'newsletter.php', formData)
      .pipe(
        map(() => undefined),
        catchError(error => throwError(() => error))
      );
  }

  subscribeLoggedIn(): Observable<void> {
    const formData = new FormData();
    formData.append('mode', 'subscribeLoggedIn');

    return this.http
      .post<{
        success: boolean;
        message: string;
      }>(environment.authority_short + 'newsletter.php', formData)
      .pipe(
        map(() => undefined),
        catchError(error => throwError(() => error))
      );
  }
}
